import Button from "@material-ui/core/Button";
import React from "react";
import { Typography } from "@material-ui/core";
import EmailOutlined from "@material-ui/icons/EmailOutlined";

export default function EmailButton(props) {
  return (
    <Button variant="contained" onClick={props.click} style={{ backgroundColor: "#344955", width: 240, margin: 5, height: 42}}>
      <EmailOutlined style={{ color: "#fff" }} />
      <Typography style={{ textTransform: "none", color: "#fff", width: 180 }}>Sign in</Typography>
    </Button>
  );
}
